import React from "react";
import PropTypes from "prop-types";

const Filter = (props) => {
    const { filterValue, handleFilterChange, filteronblur, handleClearSearch } = props;

    return (
        <div className="dictionary-search-container">
            <i
                className="fa fa-search search dictionary-search-icon"
            ></i>
            <input
                type="text"
                value={filterValue}
                onChange={(e) => handleFilterChange(e)}
                onBlur={(e) => filteronblur(e)}
                placeholder="Search Dictionary"
                className="input-box"
                autoFocus
                aria-label="Search Dictionary"
            />
            {filterValue && (
                <div onClick={handleClearSearch}>
                    <i className="fa-solid fa-xmark dictionary-close-icon"></i>
                </div>
            )}
        </div>
    );
};

Filter.propTypes = {
    filterValue: PropTypes.string,
    handleFilterChange: PropTypes.func.isRequired,
    filteronblur: PropTypes.func.isRequired,
    handleClearSearch: PropTypes.func.isRequired,
};

export default Filter;

